// React and Next.js imports
import type { GetStaticProps } from "next";
import React from "react";
import dynamic from "next/dynamic";
import { BuilderContent } from "@builder.io/react";

// Builder.io imports
import type { BasePageProps } from "@orlandohealth/build-kit";
import { SectionWrapper } from "@orlandohealth/build-kit";
import { GenericPage } from "@orlandohealth/build-kit";

const PhysicianFinder = dynamic(() => import("@orlandohealth/build-kit").then(mod => ({ default: mod.PhysicianFinder })), {
  loading: () => (
    <div className="container mx-auto py-8">
      <div className="animate-pulse">
        <div className="h-8 bg-neutral-60 rounded w-1/2 mb-6"></div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1">
            <div className="h-64 bg-neutral-60 rounded mb-4"></div>
            <div className="space-y-2">
              <div className="h-4 bg-neutral-60 rounded"></div>
              <div className="h-4 bg-neutral-60 rounded w-3/4"></div>
            </div>
          </div>
          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="h-48 bg-neutral-60 rounded"></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  ),
  ssr: false
});

// Create a custom page class that extends GenericPage without overriding too much
class PhysicianFinderPage extends GenericPage {
  protected static renderContent(props: any, model: string, router: any) {
    const _currentLocale = router?.locale || router?.defaultLocale || "en";
    
    // Use BuilderContent to access the data properly, but replace the content
    return (
      <>
        <BuilderContent
          content={props.content || null}
          options={{ includeRefs: true }}
          model={model}
        >
          {(_content, _loading, _fullContent) => {
            return (
              <PhysicianFinder
                initialBuilderPageData={props.content?.data ?? null}
              />
            );
          }}
        </BuilderContent>
      </>
    );
  }
}

// Continue using SectionWrapper for the layout
const Page = PhysicianFinderPage.createPage(SectionWrapper, "page");

// Fetch the page data from Builder.io
export const getStaticProps: GetStaticProps<BasePageProps> = async ({
  locale,
  defaultLocale,
}) => {
  // Ensure we're fetching with includeRefs: true to get all navigation references
  return GenericPage.getStaticProps(
    "/physician-finder",
    locale,
    defaultLocale,
    "page"
  );
};

export default Page;
